import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export const useInfiniteQueryUserMemberSessionPackSubscriptionUsageHistory = ({
  api,
  subscriptionId,
  enabled,
}: {
  api: ApiType;
  subscriptionId: number;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      memberQueryKeys.userMemberSessionPackSubscriptionUsageHistory(
        subscriptionId,
      ),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.memberApi.userMemberSessionPackSubscriptionUsageHistory({
          subscriptionId,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
